export interface CdnFetcherArgs {
  src: string
  width?: number
  quality?: number
}

const CDN_HOST = "baerskin.media"

const LEGACY_PREFIXES = [
  "https://assets.stg.div.haus/",
  "https://assets.div.haus/",
  "https://cdn.baerskintactical.com/",
  "https://cdn.baerskinhoodie.com/",
  "https://assets.baerskintactical.com/",
  "https://assets.stg.baerskintactical.com/",
  `https://${CDN_HOST}/`,
]

export const getCdnUrl = ({ src, width, quality }: CdnFetcherArgs) => {
  if (!src) return ""

  // Strip any legacy CDN prefixes from the source
  let file = src
  for (const prefix of LEGACY_PREFIXES) {
    if (file.startsWith(prefix)) {
      file = file.slice(prefix.length)
    }
  }

  const urlString = `https://${CDN_HOST}/${file.startsWith("/") ? file.slice(1) : file}`
  const url = new URL(urlString)

  const params = url.searchParams

  if (width) {
    params.set("width", params.get("width") || width.toString())
  }

  if (quality) {
    params.set("quality", (quality || 50).toString())
  }

  return url.href
}
